import React, { useEffect } from 'react';
import Layout from 'components/Layout';
import {
  Grid,
  Typography,
  Button as MuiButton,
  FormControlLabel,
  Switch,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useMst } from 'model/Root';

export default function AudiobookEditHubScreen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { csAudiobookStore } = useMst();
  const details = id ? csAudiobookStore.detailsById.get(id) : null;
  const loading = id ? csAudiobookStore.loadingByKey.get(`details:${id}`) : false;
  const toggling = id ? csAudiobookStore.loadingByKey.get(`toggle_status:${id}`) : false;
  const isProcessing = (details?.status ?? '').toLowerCase() === 'processing';

  useEffect(() => {
    if (id && !details) {
      csAudiobookStore.getDetails(id);
    }
  }, [id, details, csAudiobookStore]);

  return (
    <Layout title={`Äänikirja ${id ?? ''}`}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {loading ? (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={16} />
              <Typography>Ladataan…</Typography>
            </Box>
          ) : (
            <>
              <Typography variant="h6">{details?.title ?? id}</Typography>
              <Typography variant="caption" color="GrayText">
                {details?.author ?? ''} • {details?.language ?? ''} • {details?.status ?? ''}
              </Typography>
              {isProcessing && (
                <Box sx={{ mt: 2 }}>
                  <Alert severity="info">Finding TOC… This may take up to 2 minutes.</Alert>
                </Box>
              )}
              {id && (
                <Box sx={{ mt: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={(details?.status ?? '') === 'completed'}
                        onChange={async (_, checked) => {
                          const next = checked ? 'completed' : 'chapters_created';
                          csAudiobookStore.loadingByKey.set(`toggle_status:${id}`, true);
                          try {
                            await csAudiobookStore.setStatus(id, next);
                          } finally {
                            csAudiobookStore.loadingByKey.set(`toggle_status:${id}`, false);
                          }
                        }}
                        disabled={(details?.status ?? '') === 'processing' || toggling}
                      />
                    }
                    label={
                      (details?.status ?? '') === 'completed'
                        ? 'Completed'
                        : (details?.status ?? '') === 'processing'
                          ? 'Needs TOC review'
                          : 'In progress'
                    }
                  />
                </Box>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <MuiButton variant="outlined" sx={{ mr: 1 }} onClick={() => id && navigate(`/cs-audiobooks/${id}/toc`)}>
            Hallitse TOC
          </MuiButton>
          <MuiButton variant="outlined" onClick={() => id && navigate(`/cs-audiobooks/${id}/chapters`)}>
            Luvut
          </MuiButton>
        </Grid>
      </Grid>
    </Layout>
  );
}
